import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "bg-blue-50 border border-blue-200 rounded-lg p-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold text-blue-800 mb-2" }, " Thông tin biên bản giải thể ", -1)
const _hoisted_4 = { class: "grid grid-cols-2 gap-4 text-sm" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Số BBGT:", -1)
const _hoisted_6 = { class: "ml-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Toa xe:", -1)
const _hoisted_8 = { class: "ml-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Ngày vào xưởng:", -1)
const _hoisted_10 = { class: "ml-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Kế hoạch s/chữa:", -1)
const _hoisted_12 = { class: "ml-2" }
const _hoisted_13 = { class: "flex justify-end gap-2" }

import { useDateTime } from '@/core/hooks/use-date-time-hook';
import { useLoading } from '@/core/hooks/use-loading';
import { swalErrNotification, swalNotification } from '@/core/helpers/utils';
import { IBienBanGiaiTheResponseBase } from '@/core/interfaces/ApiResponses';
import { BienBanGiaiTheService } from '@/core/services/BienBanGiaiThe.service';
import VatTuNgoaiDinhMucTable from '@/components/shared/vat-tu-ngoai-dinh-muc-table/VatTuNgoaiDinhMucTable.vue';

interface IVatTuNgoaiDinhMuc {
  id: number;
  ma_vat_tu: string;
  ten_vat_tu: string;
  don_vi: string;
  so_luong: number;
  ghi_chu?: string;
  is_approved: boolean;
}

interface Props {
  isVisible: boolean;
  bienBanInfo: IBienBanGiaiTheResponseBase | null;
  vatTuItems: IVatTuNgoaiDinhMuc[];
  currentPage?: number;
  perPage?: number;
}

interface Emits {
  (e: 'update:isVisible', value: boolean): void;
  (e: 'approve-vat-tu', items: IVatTuNgoaiDinhMuc[]): void;
  (e: 'manual-close'): void;
  (e: 'approval-completed'): void;
}

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'VatTuNgoaiDinhMucModal',
  props: {
    isVisible: { type: Boolean },
    bienBanInfo: {},
    vatTuItems: {},
    currentPage: { default: 1 },
    perPage: { default: 10 }
  },
  emits: ["update:isVisible", "approve-vat-tu", "manual-close", "approval-completed"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// eslint-disable-next-line no-undef
const emit = __emit;

const { moment } = useDateTime();
const { startLoading, endLoading } = useLoading();

const formatDate = (dateString: string | undefined) => {
  if (!dateString) return '-';
  return moment(dateString).format('DD/MM/YYYY');
};

const handleClose = () => {
  // Emit manual close event to prevent unnecessary refetching
  emit('manual-close');

  // Don't emit update:isVisible here - let the parent handle the close
  // This prevents the visibility change handler from running
};

const handleBeforeClose = () => {
  // Handle before-close event (ESC key, clicking outside, etc.)
  emit('manual-close');
  return true; // Allow the modal to close
};

const handleApproveSelected = async (selectedItems: IVatTuNgoaiDinhMuc[]) => {
  try {
    // Show confirmation dialog
    const confirmed = await new Promise<boolean>((resolve) => {
      const result = window.confirm(
        `Bạn có chắc chắn muốn duyệt ${selectedItems.length} vật tư đã chọn?`
      );
      resolve(result);
    });

    if (!confirmed) {
      return;
    }

    await startLoading();

    // Call the API to approve selected VatTu items
    if (props.bienBanInfo?.id) {
      const vatTuIds = selectedItems.map((item) => item.id);
      const response = await BienBanGiaiTheService.approveVatTuCongTyDuyet(
        props.bienBanInfo.id,
        vatTuIds
      );

      console.log('response: ', response);
      // Use message from API response or fallback to default
      const message =
        response?.data?.data?.message || 'Duyệt vật tư thành công';

      await endLoading();

      // Show success notification
      await swalNotification(message, 'success');

      // Emit event to parent component to refresh data
      emit('approve-vat-tu', selectedItems);

      // Emit approval completed event to signal successful approval
      emit('approval-completed');

      // Close the modal after successful approval without triggering refetch
      // Use manual close to prevent API calls to getVatTuCongTyDuyetById
      emit('manual-close');
    }
  } catch (error) {
    await endLoading();
    // Use error message from API response or fallback to default
    await swalErrNotification(error, 'Có lỗi xảy ra khi duyệt vật tư');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_dialog_auto_focus = _resolveDirective("dialog-auto-focus")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.isVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:isVisible', $event))),
    title: "Chi tiết vật tư ngoài định mức",
    width: "90%",
    "before-close": handleBeforeClose,
    "custom-class": "vat-tu-ngoai-dinh-muc-modal"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_el_button, { onClick: handleClose }, {
          default: _withCtx(() => [
            _createTextVNode("Đóng")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.bienBanInfo?.so_bien_ban), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_7,
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.bienBanInfo?.toa_xe?.ma_toa_xe) + " - " + _toDisplayString(_ctx.bienBanInfo?.toa_xe?.ten_toa_xe), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_9,
                _createElementVNode("span", _hoisted_10, _toDisplayString(formatDate(_ctx.bienBanInfo?.ngay_vao_xuong)), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_11,
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.bienBanInfo?.ke_hoach_sua_chua?.ten_ke_hoach), 1)
              ])
            ])
          ])
        ]),
        _createVNode(VatTuNgoaiDinhMucTable, {
          items: _ctx.vatTuItems,
          "cur-page": _ctx.currentPage,
          "per-page": _ctx.perPage,
          onApproveSelected: handleApproveSelected
        }, null, 8, ["items", "cur-page", "per-page"])
      ])), [
        [_directive_dialog_auto_focus, props.isVisible]
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})